export default "__VITE_ASSET__WX$cj0$c__"